import React, { useState, useEffect } from "react";
import { Form, Button, Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import Swal from "sweetalert2";
import Layout from "../../../../layout/default"; // Based on the folder structure
import { useNavigate } from "react-router-dom";
import {
  FaUserAlt,
  FaUserPlus,
  FaPhoneAlt,
  FaIdCard,
  FaCheckCircle,
  FaRegIdCard,
  FaUserTag,
} from "react-icons/fa";

const CreateUserDetails = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    middle_name: "",
    phone_1: "",
    phone_2: "",
    // email: "",
    aadhar_number: "",
    pancard_number: "",
  });

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check for authentication token
    const authToken = localStorage.getItem("authToken");
    // Check if any field is empty
    if (!formData.first_name || !formData.last_name || !formData.aadhar_number || !formData.pancard_number || !formData.phone_1) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Form',
        text: 'Please fill in all the required fields before submitting.',
      });
      return;
    }


    if (!authToken) {
      Swal.fire({
        icon: "error",
        title: "Authentication Required",
        text: "Please log in to proceed.",
      });
      navigate("/shop/auths/login", { replace: true });
      return;
    }

    // Aadhar Number Validation (must be 12 digits)
    if (!/^\d{12}$/.test(formData.aadhar_number)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Input',
        text: 'Aadhar number must be exactly 12 digits.',
      });
      return;
    }

    // PAN Card Validation (must be 8 characters alphanumeric)
    if (!/^[A-Z]{5}\d{4}[A-Z]{1}$/.test(formData.pancard_number)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Input',
        text: 'PAN card number must be in a valid format (5 letters, 4 digits, and 1 letter). Example: ABCDE1234F.',
      });
      return;
    }

    // Phone Number Validation (must be 10 digits)
    if (!/^\d{10}$/.test(formData.phone_1)) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Input',
        text: 'Phone number must be exactly 10 digits.',
      });
      return;
    }


    try {
      const response = await axios.post(`${process.env.REACT_APP_HOST}api/user-details`, formData, {
        headers: {
          "Authorization": `Bearer ${authToken}`, // Attach token to header
        },
      });
      Swal.fire("Success!", "Successfully Added User Details!", "success");
      navigate("/shop");
    } catch (error) {
      let errorMessage = " failed. Please try again.";
      if (error.response && error.response.data) {
        // if (error.response.data.errors === 'Email already exists.') {
        //   errorMessage = 'The email address is already registered. Please use a different email.';
        // } else 
        if (error.response.data.errors === 'Aadhar number already exists.') {
          errorMessage = 'The Aadhaar number is already registered. Please use a different Aadhaar number.';
        } else {
          errorMessage = error.response.data.errors || errorMessage;
        }
      }

      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: errorMessage,
      });
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <Layout title="User Details">
      <Container className="mt-4">
        <Row className="justify-content-md-center mt-4">
          <Col md={8} className="shadow p-4 rounded">
            <h3 className="mb-4 text-center text-primary">

              Add User Details
            </h3>

            <Form>
              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="first_name"
                      value={formData.first_name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="last_name"
                      value={formData.last_name}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Middle Name (Optional)</Form.Label>
                <Form.Control
                  type="text"
                  name="middle_name"
                  value={formData.middle_name}
                  onChange={handleChange}
                />
              </Form.Group>

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Phone Number 1</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone_1"
                      value={formData.phone_1}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Phone Number 2 (Optional)</Form.Label>
                    <Form.Control
                      type="text"
                      name="phone_2"
                      value={formData.phone_2}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Uncomment to use Email */}
              {/* <Form.Group className="mb-3">
        <Form.Label><FaEnvelope className="me-2" />Email</Form.Label>
        <Form.Control
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          required
        />
      </Form.Group> */}

              <Row className="mb-3">
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Aadhar Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="aadhar_number"
                      value={formData.aadhar_number}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>PAN Card Number</Form.Label>
                    <Form.Control
                      type="text"
                      name="pancard_number"
                      value={formData.pancard_number}
                      onChange={handleChange}
                      required
                    />
                  </Form.Group>
                </Col>
              </Row>

              <div className="text-end">
                <Button variant="success" className="mt-3" onClick={handleSubmit}>
                 
                  Submit
                </Button>
              </div>
            </Form>
          </Col>
        </Row>
      </Container>
      <br />
      <br />
      <br />
      <br />
    </Layout>
  );
};

export default CreateUserDetails;
